module.exports = __webpack_public_path__ + "img/16_icon.fd82b6a8.png";